import React from 'react';

import { Text as MobiusText } from '@simplybusiness/mobius-core';

const Text = (props) => (
  <MobiusText
    component="p"
    margin={0}
    fontSize={14}
    color="#111118"
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  />
);

export default Text;
